import { useMemo } from "react";
import { useSelector } from "react-redux";
import { resolveThemeColors } from "./resolveThemeColors";

export function useAppTheme() {
  const activeAppTheme = useSelector(
    (state) => state.dashboard?.activeAppTheme,
  );

  return useMemo(
    () => resolveThemeColors(activeAppTheme),
    [activeAppTheme],
  );
}
